// Version française originale des textes de l'interface.
// Conservée pour référence et pour pouvoir repasser l'étude en français.
const fr = {
  documentTitle: "Test personnalité",

  common: {
    previous: "Précédent",
    next: "Suivant",
    fillQuestionnaire: "Remplir le Questionnaire",
    initialPrompt: "Prompt initial:",
  },

  home: {
    title: "Dorian Gray",
    projectHeading: "Présentation du projet",
    projectText:
      "Le projet DORIAN GRAY étudie le lien entre les troubles cognitifs légers et les maladies cardiovasculaires afin de développer une stratégie pour la détection précoce et la prévention.",
    appHeading: "Application mobile",
    appText1:
      "L'application proposera des exercices sous forme de jeux innovants basés sur un coach virtuel, combinant entraînement cognitif et activité physique dans une expérience personnalisée et attrayante.",
    appText2:
      "Cette approche vise à améliorer la santé cérébrale et cardiaque, promouvoir un changement de comportement et réduire le déclin cognitif.",
    coachHeading: "Rôle du coach virtuel",
    coachText1:
      "Le coach virtuel accompagne l'utilisateur au quotidien pour organiser, conseiller et motiver la réalisation d'exercices variés.",
    coachText2:
      "Il agit également comme professeur pour informer sur la santé et les bienfaits des exercices, comme compagnon pour échanger, et comme support pour l'utilisation de l'application.",
    coachText3:
      "Polyvalent, il constitue une pièce majeure de l'application en accompagnant l'utilisateur dans son parcours.",
  },

  etude: {
    title: "Etude",
    intro1:
      "Nous allons vous présenter 4 coachs virtuels avec leur propre personnalité. L'objectif est d'identifier, selon vous, la personnalité la plus adaptée pour recommander des exercices et vous accompagner.",
    intro2:
      "Vous devrez interagir avec chaque coach virtuel tout en prenant des notes afin de répondre à un questionnaire. Prenez le temps de découvrir chaque coach et de vous familiariser avec leurs comportements.",
    observeHeading: "Points à observer",
    observe: [
      "Quelles phrases vous ont marqué et pourquoi ?",
      "Qu'est-ce qui vous motive à continuer la discussion ?",
      "Qu'est-ce qui vous incite à suivre les recommandations ?",
    ],
    note: "**Important :** les conversations sont **éphémères**. Si vous quittez un coach (via **Retour**) puis revenez plus tard, l'historique sera perdu et vous démarrerez une nouvelle discussion. Prenez des notes avant de quitter la discussion.",
    scenariosHeading: "Scénarios de test",
    scenariosColScenario: "Scénario",
    scenariosColTask: "Votre tâche",
    scenariosColPrompt: "Exemple de message d'ouverture",
    scenarios: [
      {
        name: "1. Planifier un exercice",
        task: "Demandez au coach de vous aider à planifier une séance d'exercice douce.",
        prompt:
          "« J'aimerais planifier une séance d'exercice douce pour jeudi matin. Pouvez-vous m'aider à l'ajouter à mon planning ? »",
      },
      {
        name: "2. Objectif de la semaine",
        task: "Demandez au coach de vous aider à définir un objectif réaliste pour cette semaine.",
        prompt: "« Pouvez-vous m'aider à définir un objectif réaliste pour cette semaine ? »",
      },
      {
        name: "3. Information santé générale",
        task: "Demandez pourquoi une activité physique régulière est bénéfique.",
        prompt:
          "« Pouvez-vous m'expliquer, de manière générale, pourquoi une activité physique régulière est bonne pour le cœur et le cerveau ? »",
      },
      {
        name: "4. Aide avec l'application",
        task: "Demandez au coach de vous aider à trouver une information dans l'application.",
        prompt:
          "« Je ne trouve pas la page avec mes informations de santé dans l'application. Pouvez-vous m'aider ? »",
      },
      {
        name: "5. Conversation sociale (si le temps le permet)",
        task: "Faites connaissance avec le coach et son rôle dans l'application.",
        prompt:
          "« J'aimerais faire votre connaissance. Que pouvez-vous faire dans cette application ? »",
      },
    ],
  },

  afterCoach: {
    title: "Après chaque coach",
    subtitle: "Prenez des notes",
    intro:
      "Avant de passer au questionnaire, prenez quelques notes (sur papier ou en les copiant ailleurs), car vous ne pourrez pas revenir à la conversation plus tard.",
    notesHeading: "En particulier, notez :",
    notes: [
      "Trois réponses ou moments mémorables.",
      "Ce que vous avez aimé.",
      "Ce que vous n'avez pas aimé ou trouvé inconfortable.",
    ],
    gridIntro: "Vous évaluerez chaque coach selon la grille suivante :",
    gridAlt: "Grille d'évaluation",
    questionnaireNote:
      "Vous remplirez un court questionnaire après chaque coach, puis un questionnaire final comparant les quatre coachs.",
  },

  chatSelection: {
    title: "Coach virtuel",
    description: "Veuillez choisir un agent pour commencer une conversation",
  },

  questionnaire: {
    title: "Questionnaire",
    description:
      "Nous allons vous demander maintenant de prendre le temps et de classer par ordre de préférence les coachs virtuels de 1 (préféré) à 4. Vous pouvez retourner à la phase précédente pour rediscuter avec les coachs virtuels.",
  },

  chat: {
    back: "Retour",
    headerSuffix: "Chat",
    welcome:
      "Bonjour, je suis un agent conversationnel. Comment puis-je vous aider aujourd'hui?",
    defaultAgentName: "Agent Default",
    placeholder: (name) => `Parlez avec ${name}...`,
    typing: (name) => `${name} réflechit...`,
    defaultPlaceholder: "Votre message...",
    defaultHeaderTitle: "Interface de Chat",
    defaultTyping: "L'agent réfléchit...",
    you: "Vous",
    connectionError:
      "Désolé, je ne peux pas me connecter au serveur pour le moment. Veuillez réessayer plus tard.",
    genericError: (msg) => `Désolé, il y a eu un erreur: ${msg}`,
  },

  // Instruction finale du prompt système envoyé au modèle.
  promptTask:
    "TASK: Add the coach's next utterance. Respond in French, one to two sentences, no explanations.",
};

export default fr;
